// Centralised checkout + tracking utilities.
// All CTAs on the page MUST use these so we never create dead buttons
// and every registration attempt is tracked consistently.

// Primary Razorpay checkout for the ₹199 workshop registration.
// If a different upsell/order-bump checkout URL is provided later,
// pass it explicitly to goToCheckout(url).
export const CHECKOUT_URL = "https://rzp.io/rzp/FDfaiUN";
export const TICKET_PRICE = 199;
export const CURRENCY = "INR";
export const WEBINAR_NAME = "AI Money Machine System";

// Read current query string and forward supported UTM / tracking params
// so downstream attribution (Meta, GA, Razorpay) is preserved.
const FORWARD_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
  "ref",
];

export function buildCheckoutUrl(base = CHECKOUT_URL) {
  try {
    const current = new URLSearchParams(window.location.search);
    const target = new URL(base);
    FORWARD_PARAMS.forEach((p) => {
      const v = current.get(p);
      if (v) target.searchParams.set(p, v);
    });
    return target.toString();
  } catch (e) {
    return base;
  }
}

// Safe tracking. Fires Meta Pixel + gtag only if they are present.
// This means if the operator later adds fbq / gtag script tags,
// events will start flowing without a code change.
export function track(event, params = {}) {
  try {
    if (typeof window === "undefined") return;
    // Meta Pixel
    if (typeof window.fbq === "function") {
      // Map to standard events where possible
      const standardEvents = new Set([
        "PageView",
        "ViewContent",
        "Lead",
        "InitiateCheckout",
        "Purchase",
        "AddToCart",
        "CompleteRegistration",
      ]);
      if (standardEvents.has(event)) {
        window.fbq("track", event, params);
      } else {
        window.fbq("trackCustom", event, params);
      }
    }
    // GA4 / Google Tag
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
    // Console breadcrumb in dev
    if (process.env.NODE_ENV !== "production") {
      console.debug("[track]", event, params);
    }
  } catch (e) {
    // never break UX because of tracking
  }
}

export function goToCheckout(source = "unknown", base = CHECKOUT_URL) {
  const url = buildCheckoutUrl(base);
  track("InitiateCheckout", {
    content_name: WEBINAR_NAME,
    value: TICKET_PRICE,
    currency: CURRENCY,
    source,
  });
  track("CTA_Click", { source, destination: url });
  // Open in same tab so back-button UX is preserved for buyers who abandon
  window.location.href = url;
}
